import React from 'react';
import styles from './Hero.module.css';

const Hero = ({
  screenshotSrc = '/screenDashboard.png',
  screenshotAlt = 'LeanWeek app screenshot',
}) => {
  return (
    <section className={styles.heroContainer}>
      <div className={styles.heroGlow} />

      <div className={styles.content}>
        <span className={styles.badge}>
          <span className={styles.badgeDot} />
          AI Weekly Planner
        </span>

        <h1 className={styles.title}>
          A simple AI weekly fitness planner for people who want{' '}
          <span>practical fat loss guidance</span> without friction.
        </h1>

        <p className={styles.subtitle}>
          LeanWeek helps you generate a modern 7-day plan with daily step goals,
          workout duration guidance, and estimated calorie burn — all in a
          privacy-first, zero-friction experience.
        </p>

        <div className={styles.ctaGroup}>
          <button className={styles.primaryBtn}>Join Early Access</button>
          <button className={styles.secondaryBtn}>See Features</button>
        </div>
      </div>

      <div className={styles.mockupContainer}>
        <div className={styles.deviceGlow} />

        <div className={styles.iphoneMockup}>
          <div className={styles.iphoneInner}>
            <div className={styles.dynamicIsland} />

            <img
              src={screenshotSrc}
              alt={screenshotAlt}
              className={styles.iphoneScreen}
            />
          </div>

          <div className={styles.sideButtonLeftTop} />
          <div className={styles.sideButtonLeftBottom} />
          <div className={styles.sideButtonRight} />
        </div>
      </div>
    </section>
  );
};

export default Hero;